export const stringifyOnClient = (args?: object | undefined) => {
    return global.__SERVER__ === true ? args : args && JSON.stringify(args)
}